var _style, _defs, _path, _path2, _circle;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } } return target; }
import * as React from "react";
function SvgLogoSpinner(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "ee7kguxi1b5b1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 120 120",
    shapeRendering: "geometricPrecision",
    textRendering: "geometricPrecision",
    width: 120,
    height: 120,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n        #ee7kguxi1b5b2 {animation: ee7kguxi1b5b2_f_o 1000ms linear infinite normal forwards}@keyframes ee7kguxi1b5b2_f_o { 0% {fill-opacity: 0.400000} 40% {fill-opacity: 1} 80% {fill-opacity: 0.400000} 100% {fill-opacity: 0.400000} }#ee7kguxi1b5b3 {animation: ee7kguxi1b5b3_f_o 1000ms linear infinite normal forwards}@keyframes ee7kguxi1b5b3_f_o { 0% {fill-opacity: 0.400000} 40% {fill-opacity: 1} 80% {fill-opacity: 0.400000} 100% {fill-opacity: 0.400000} }#ee7kguxi1b5b4 {animation: ee7kguxi1b5b4_f_o 1000ms linear infinite normal forwards}@keyframes ee7kguxi1b5b4_f_o { 0% {fill-opacity: 0.500000} 40% {fill-opacity: 1} 80% {fill-opacity: 0.500000} 100% {fill-opacity: 0.500000} }#ee7kguxi1b5b5 {\n        animation-name: ee7kguxi1b5b5_c_o, ee7kguxi1b5b5_s_do, ee7kguxi1b5b5_s_da;\n        animation-duration: 1000ms;\n        animation-fill-mode: forwards;\n        animation-timing-function: linear;\n        animation-direction: normal;\n        animation-iteration-count: infinite;\n        }@keyframes ee7kguxi1b5b5_c_o { 0% {opacity: 0.300000} 40% {opacity: 1} 80% {opacity: 0.300000} 100% {opacity: 0.300000} }@keyframes ee7kguxi1b5b5_s_do { 0% {stroke-dashoffset: 358.140000} 40% {stroke-dashoffset: 0} 80% {stroke-dashoffset: -358.140000} 100% {stroke-dashoffset: -358.140000} }@keyframes ee7kguxi1b5b5_s_da { 0% {stroke-dasharray: 358.140000} 40% {stroke-dasharray: 358.140000} 100% {stroke-dasharray: 358.140000} }\n    ")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "ee7kguxi1b5b5-stroke",
    x1: 0,
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    spreadMethod: "pad",
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "ee7kguxi1b5b5-stroke-0",
    offset: "0%",
    stopColor: "rgb(1,188,212)"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "ee7kguxi1b5b5-stroke-1",
    offset: "99%",
    stopColor: "rgba(1,188,212,0.5)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "ee7kguxi1b5b2",
    style: {
      mixBlendMode: "darken"
    },
    d: "M16.196103,38.343107L2.401940,50L21.246882,50L25.483257,45.944288L16.196103,38.343107ZM21.246882,44.292206L16.196103,40.198669L11.311506,44.292206L14.623383,44.292206L16.933994,45.547789L16.933994,44.292206L21.246882,44.292206Z",
    transform: "matrix(0.84257319119925 0 0 0.85786150986516 19.01868823642094 23.54088583120228)",
    clipRule: "evenodd",
    fill: "rgb(1,187,212)",
    fillOpacity: 0.4,
    fillRule: "evenodd",
    stroke: "rgb(1,188,212)",
    strokeWidth: 0.5,
    strokeLinecap: "square",
    strokeLinejoin: "bevel",
    strokeDashoffset: 91.62,
    strokeDasharray: 91.62
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "ee7kguxi1b5b3",
    d: "M152.747110,27L142.562199,31.554556L147.082745,37L166.143420,37L152.747110,27ZM147.910440,30.562873L152.747110,28.591815L155.630509,30.562873L153.729770,30.566039L151.572789,32.103503L151.572789,30.566039L147.910440,30.562873Z",
    transform: "matrix(0.99221633040618 0 0 1 -65.94169466000049 29.43396131999998)",
    clipRule: "evenodd",
    fill: "rgb(1,187,212)",
    fillOpacity: 0.4,
    fillRule: "evenodd",
    stroke: "rgb(1,188,212)",
    strokeWidth: 0.5,
    strokeLinecap: "square",
    strokeDashoffset: 121.61,
    strokeDasharray: 121.61
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "ee7kguxi1b5b4",
    d: "M71.299612,5.434353L51.541067,25L88.094465,25L71.299612,5.434353ZM64.242020,14.700596L71.299612,7.556998L77.353516,14.700596L73.264895,14.700596L69.825650,17.000035L70.589688,14.700596L64.242020,14.700596Z",
    transform: "matrix(0.95486392202705 0 0 1 -8.17385185473246 41.43396131999998)",
    clipRule: "evenodd",
    fill: "rgb(1,187,212)",
    fillOpacity: 0.5,
    fillRule: "evenodd",
    stroke: "rgb(1,188,212)",
    strokeWidth: 0.5,
    strokeLinecap: "square",
    strokeDashoffset: 153.15,
    strokeDasharray: 153.15
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "ee7kguxi1b5b5",
    r: 57,
    transform: "matrix(1 0 0 1 60.00000000000004 60.00000000000004)",
    opacity: 0.3,
    fill: "none",
    stroke: "url(#ee7kguxi1b5b5-stroke)",
    strokeWidth: 3,
    strokeDashoffset: 358.14,
    strokeDasharray: 358.14
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoSpinner);
export default __webpack_public_path__ + "static/media/logoSpinner.365574b5721580013ff3f8832100ad16.svg";
export { ForwardRef as ReactComponent };